import Cookie from 'js-cookie'

const cookie = Cookie

cookie.withAttributes({
  secure: import.meta.env.PROD,
})

export { cookie }
